<template>
  <!--应收生成批次号提示-->
  <el-dialog
    :append-to-body="true"
    :title="$t('receivablePayable.tips')"
    :visible.sync="showGenerate"
    width="50%"
  >
    <div style="height: 40vh;overflow: hidden;">
      <div style="height: 100%;overflow: auto;">
        <!--对账批次生成成功！-->
        <div style="margin-bottom: 20px;">{{ $t('receivablePayable.ReconciliationBatchGenerationSuccessful') }}</div>
        <!--对账批次号：-->
        <div>{{ $t('receivablePayable.ReconciliationBatchNumber') }}
          <div v-for="(item, index) in batchNumber" :key="index" style="margin: 0 10px 5px 0;">
            <span>{{ item.replace('~', '\n') }}</span>
          </div>
        </div>
      </div>
      <textarea id="message5" />
    </div>
    <span slot="footer" class="dialog-footer">
      <!--取 消-->
      <el-button @click="colsDialog">{{ $t('basicData.Cancel') }}</el-button>
      <!--复制批次号-->
      <el-button type="primary" @click="copyBatchNumber">{{
        $t('receivablePayable.CopyTheBatchNumber')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'BatchNumberDialog',

  props: {
    batchNumber: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showGenerate: false
    };
  },

  methods: {
    open() {
      this.showGenerate = true;
    },
    colsDialog() {
      this.showGenerate = true;
    },
    // 复制批次号
    copyBatchNumber() {
      const input = document.getElementById('message5');
      const num = [];
      this.batchNumber.map(item => {
        num.push(item.split('~')[0]);
      });
      input.value = num.join(','); // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行浏览器复制命令
      this.$message.success(this.$t('orderCenterCont.ReplicationSucceeded')); // '复制成功'

      this.colsDialog();
    }
  }
};
</script>
